import { createContext } from 'react'

import { RestClientInstance } from '../../shared/create-client'

export type RestClientContextType = {
  client: RestClientInstance
}

export const RestClientContext = createContext<RestClientContextType | null>(null)
